import React from 'react';

import {
  useRecordContext,
  SelectField,
  TextField,
} from 'react-admin';

import {
  Box,
  Grid,
  Typography,
} from '@mui/material';

import { mapRuleParams, mapRuleParamsSummary, ruleNameChoices } from '../../../ruleFeatures';
import { Rule } from '../../../../../utilities/schemas/rules';

const RuleLogic = () => {
  const record = useRecordContext<Rule>();

  if (!record) return null;

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Rule type</Typography>
          <SelectField choices={ruleNameChoices} source="name" />
        </Box>
      </Grid>
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Rule name</Typography>
          <TextField source="customName" emptyText="-" />
        </Box>
      </Grid>
      <Grid
        container
        spacing={2}
        display={mapRuleParams[record.name]?.length > 0 ? 'flex' : 'none'}
        size={12}
      >
        <Grid size={12}>
          <Typography variant="label" fontWeight="bold">Rule parameters</Typography>
        </Grid>
        {React.createElement(mapRuleParamsSummary[record.name])}
      </Grid>
    </Grid>
  );
};

export default RuleLogic;
